import { mailStore } from 'owa-mail-store';
import ConversationNode from 'owa-service/lib/contract/ConversationNode';
import ConversationSortOrder from 'owa-service/lib/contract/ConversationSortOrder';
import { action, select } from 'satcheljs/lib/legacy';
import getItemTailoredXpData, { GetTailoredXpDataState } from './getItemTailoredXpData';
import { getConversationFromNodes } from 'owa-mail-store';

export default action('getConversationTailoredXpData')(
    select<GetTailoredXpDataState>({
        items: () => mailStore.items,
    })(function getConversationTailoredXpData(
        conversationNodes: ConversationNode[],
        conversationSortOrder: ConversationSortOrder,
        state?: GetTailoredXpDataState
    ) {
        // Check the first node's items for TxP data.
        const node = getConversationFromNodes(conversationNodes, conversationSortOrder);
        node.Items.forEach(newItem => {
            getItemTailoredXpData(newItem, state);
        });
    })
);
